import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { REPORTS_API } from "./apiRoutes";

interface UseGetInvoiceReportsProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getInvoiceReports = async (data: any) =>
  await axiosAuth.post(`${REPORTS_API(data?.communityId)}/`, data);

const useGetInvoiceReports = ({
  data,
  queryParams,
}: UseGetInvoiceReportsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["invoice-reports"],
    queryFn: () => getInvoiceReports(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetInvoiceReports;
